import type { RouteRecordRaw } from 'vue-router';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');
const MultiTransactionMovements = () =>
  import('@/modules/multiTransactionV2/pages/MovementHistoryList/index.vue');
const MultiTransactionMovementDetail = () =>
  import('@/modules/multiTransactionV2/pages/MovementDetail/index.vue');

/**
 * Rutas para visualización de movimientos de multienvíos
 * Independientes del flujo de creación (multiTransactionV2)
 */
export const multiTransactionMovementsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/multi-transaction/movements',
    name: 'multi-transaction-movements',
    component: MainLayout,
    redirect: {
      name: 'multi-transaction-movements-list',
    },
    meta: {
      title: 'Envíos múltiples',
      subTitle: 'last-connection',
      accessRol: {
        section: 'TRANSACTIONS',
        actions: ['VIEW_MULTI_SENDS'],
      },
    },
    children: [
      {
        path: '',
        name: 'multi-transaction-movements-list',
        component: MultiTransactionMovements,
      },
      {
        path: ':multiTransactionId',
        name: 'multi-transaction-movement-detail',
        component: MultiTransactionMovementDetail,
        meta: {
          title: 'Detalle de envío múltiple',
        },
      },
    ],
  },
];
